<template>
  <asd20-school-directory
    :initial-view="initialView"
    :initial-boundary-visible="initialBoundaryVisible"
  />
</template>

<script>
import Asd20SchoolDirectory from '@/components/organisms/Asd20SchoolDirectory'

export default {
  name: 'SchoolsPage',
  components: { Asd20SchoolDirectory },
  props: {
    initialView: { type: String, default: 'list' },
    initialBoundaryVisible: { type: Boolean, default: true },
  },
  mounted() {
    console.log('SchoolsPage mounted. initialView:', this.initialView)
  },
}
</script>
